import {
  useQueryStates,
  parseAsInteger,
  parseAsStringLiteral,
  parseAsString,
} from 'nuqs'

export const useI9AltDocsHubQueryState = () =>
  useQueryStates(
    {
      altGroupBy: parseAsStringLiteral(['state', 'market', 'date']).withDefault(
        'date'
      ),
      altDateSort: parseAsStringLiteral(['asc', 'desc']).withDefault('asc'),
      altState: parseAsString,
      altMarket: parseAsString,
      altWorkerId: parseAsInteger,
      altWorkerSearch: parseAsString.withDefault(''),
    },
    {
      urlKeys: {
        altGroupBy: 'alt-group',
        altDateSort: 'alt-date-sort',
        altState: 'alt-state',
        altMarket: 'alt-market',
        altWorkerId: 'alt-worker-id',
        altWorkerSearch: 'alt-q',
      },
    }
  )
